import { render } from "./Template1.vue?vue&type=template&id=f98c4ba4&scoped=true"
import script from "./Template1.vue?vue&type=script&lang=ts"
export * from "./Template1.vue?vue&type=script&lang=ts"

import "./Template1.vue?vue&type=style&index=0&id=f98c4ba4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f98c4ba4"

export default script